import {
    SearchIdAction,
    SearchIdActionTypes
} from "../interfaces/context/searchContextInterfaces";

export const searchIdReducer = (state: string, action: SearchIdAction) => {
    switch (action.type) {
    case SearchIdActionTypes.updateSearchId:
        return action.payload;
    default:
        return state;
    }
};
